module.exports = __webpack_public_path__ + "static/media/TW-father-joe-desktop-1220x150@2x.32b07187.jpg";